<template>
  <b-card>
    <b-row>
      <b-col md="12">
        <filters
          @filtersUpdated="filtersChangeHandler"
        />
      </b-col>
    </b-row>
    <buyer-sales :filters="filters" />
  </b-card>
</template>

<script>
import Filters from '@/components/Accounts/SalesTargets/Filters/Filters.vue'
import BuyerSales from '@/components/Accounts/SalesTargets/BuyerSales.vue'
import { BRow, BCol, BCard } from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    Filters,
    BuyerSales,
  },
  data() {
    return {
      filtersInitialized: false,
      filters: {},
    }
  },
  methods: {
    filtersChangeHandler(filterData) {
      this.filters = filterData
      if (this.filtersInitialized === false) {
        this.filtersInitialized = true
      }
    },
  },
}
</script>
